import {
  createImmutableMapFromObject,
} from '../../common/collection/collectionUtils';

const voltranDeserializers = {
  fragmentsMap(data) {
    return createImmutableMapFromObject(
      data
    )
  },
};

export default voltranDeserializers;
